import { routes } from './routes';
import { accounting } from './strings/accounting';
import { acutePhysicalTherapist } from './strings/acute-physical-therapist';
import { billing } from './strings/billing';
import { eligibility } from './strings/eligibility';
import { hingeConnect } from './strings/hinge-connect/hinge-connect';
import { login } from './strings/login';
import { memberData } from './strings/member-data';
import { memberDataServices } from './strings/member-data-services';
import { patients } from './strings/patients';
import { roi } from './strings/roi';

const text = {
  login,
  patients,
  acutePhysicalTherapist,
  accounting,
  billing,
  hingeConnect,
  roi,
  eligibility,
  memberData,
  memberDataServices,
};

export { text, routes };
